export default {
    'DASHBOARD-VIEW':{
        key: 'dashBoard-view',
        label: '实时人效-查看'
    },
    'TAB-CLICK-BACKLOGBOARD': {
        key: 'tab-click-backlogboard',
        label: '积压看板-查看'
    },
    'DASHBOARD-TAB-CLICK':{
        key:'dashboard-tab-click',
        label:'实时人效-tab-点击'
    },
    'TAB-CLICK-HUMANDASHBOARD':{
        key:'tab-click-humanDashboard',
        label:'人效看板Tab'
    },
    'TAB-CLICK-WAREHOSUEBOARD':{
        key:'tab-click-warehouseboard',
        label:'按仓汇总Tab'
    },
    'TAB-CLICK-OWNERBOARD':{
        key:'tab-click-ownerboard',
        label:'按货主Tab'
    },
    'TAB-CLICK-MANHOURBOARD':{
        key:'tab-click-manhourBoard',
        label:'小时人效Tab'
    },
    'TAB-CLICK-HOURLYBOARD':{
        key:'tab-click-hourlyBoard',
        label:'小时看板Tab'
    },
    'ob_today_backlog_10':{
        key:'ob_today_backlog_10',
        label:'普通订单-今日积压'
    },
    'ob_today_backlog_18':{
        key:'ob_today_backlog_18',
        label:'大宗订单-今日积压'
    },
    'ob_today_backlog_13':{
        key:'ob_today_backlog_13',
        label:'退供单-今日积压'
    },
    'inbound_wait_finish_asn_it01':{
        key:'inbound_wait_finish_asn_it01',
        label:'一般入库单-待完验'
    },
    'inbound_wait_putaway_it01':{
        key:'inbound_wait_putaway_it01',
        label:'一般入库单-待上架'
    },
    'inbound_wait_finish_asn_it17':{
        key:'inbound_wait_finish_asn_it17',
        label:'售后入库单-待完验'
    },
    'inbound_wait_putaway_it17':{
        key:'inbound_wait_putaway_it17',
        label:'售后入库单-待上架'
    },
    'inbound_wait_finish_asn_it03':{
        key:'inbound_wait_finish_asn_it03',
        label:'客退入库单-待完验'
    },
    'inbound_wait_putaway_it03':{
        key:'inbound_wait_putaway_it03',
        label:'客退入库单-待上架'
    },
    'inbound_wait_putaway_ReturnRack':{
        key:'inbound_wait_putaway_ReturnRack',
        label:'库内返架-待上架'
    },
    'invop_diff_backlog':{
        key:'invop_diff_backlog',
        label:'差异中心积压'
    },
    'invop_replenishment':{
        key:'invop_replenishment',
        label:'补货积压'
    },
    'invop_trans_move':{
        key:'invop_trans_move',
        label:'人区移库积压'
    },
    'robot_move_stock':{
        key:'robot_move_stock',
        label:'人区移入机区积压'
    },
    'invop_owner_change':{
        key:'invop_owner_change',
        label:'货权转移积压'
    },
    'invop_vas':{
        key:'invop_vas',
        label:'VAS积压'
    },
    'invop_level_change':{
        key:'invop_level_change',
        label:'等级变更积压'
    },
    'front_master_logistics_property_task_backlog':{
        key:'front_master_logistics_property_task_backlog',
        label:'物流属性采集积压'
    },
    'inbound_init_exception':{
        key:'inbound_init_exception',
        label:'入库初始化异常'
    },
    'ob_init_exception':{
        key:'ob_init_exception',
        label:'出库初始化异常'
    },
    'ob_locate_exception':{
        key:'ob_locate_exception',
        label:'定位异常'
    },
    'ob_assign_exception':{
        key:'ob_assign_exception',
        label:'任务分配异常'
    },
    'inbound_putaway_wms_exception_handle':{
        key:'inbound_putaway_wms_exception_handle',
        label:'人区上架异常'
    },
    'inbound_putaway_robot_exception_handle':{
        key:'inbound_putaway_robot_exception_handle',
        label:'机区上架异常'
    },
    'ob_trouble_order':{
        key:'ob_trouble_order',
        label:'病单'
    },
    'OUTBOUND-QUERY-CLICK':{
        key:'outbound-query-click',
        label:'出库进度监控查询'  
    },
    'INBOUND-QUERY-CLICK':{
        key:'inbound-query-click',
        label:'入库进度监控查询'  
    },
    'wms_inbound_received_piece_kpi_hourly_query':{
        key:'wms_inbound_received_piece_kpi_hourly_query',
        label:'入库-验收小时人效-查询'
    },
    'wms_inbound_putaway_piece_kpi_hourly_query':{
        key:'wms_inbound_putaway_piece_kpi_hourly_query',
        label:'入库-上架小时人效-查询'
    },
    'wms_inbound_received_piece_kpi_hourly_export':{
        key:'wms_inbound_received_piece_kpi_hourly_export',
        label:'入库-验收小时人效-导出'
    },
    'wms_inbound_putaway_piece_kpi_hourly_export':{
        key:'wms_inbound_putaway_piece_kpi_hourly_export',
        label:'入库-上架小时人效-导出'
    },
    'wms_ob_pick_piece_kpi_hourly_query':{
        key:'wms_ob_pick_piece_kpi_hourly_query',
        label:'出库-拣货小时人效-查询'
    },
    'wms_ob_pack_order_kpi_hourly_query':{
        key:'wms_ob_pack_order_kpi_hourly_query',
        label:'出库-打包小时人效-查询'
    },
    'wms_ob_check_piece_kpi_hourly_query':{
        key:'wms_ob_check_piece_kpi_hourly_query',
        label:'出库-复核小时人效-查询'
    },
    'wms_ob_pick_piece_kpi_hourly_export':{
        key:'wms_ob_pick_piece_kpi_hourly_export',
        label:'出库-拣货小时人效-导出'
    },
    'wms_ob_pack_order_kpi_hourly_export':{
        key:'wms_ob_pack_order_kpi_hourly_export',
        label:'出库-打包小时人效-导出'
    },
    'wms_ob_check_piece_kpi_hourly_export':{
        key:'wms_ob_check_piece_kpi_hourly_export',
        label:'出库-复核小时人效-导出'
    },
}